const read = (value, camelName, pascalName) => (
  value?.[camelName] ?? value?.[pascalName]
);

const id = value => String(read(value, 'id', 'Id') || '');

export function itemContentIssues(item, itemTypes = []) {
  const itemType = itemTypes.find(candidate => (
    id(candidate) === String(read(item, 'typeId', 'TypeId') || '')
  ));
  if (!Boolean(read(itemType, 'isEquipment', 'IsEquipment'))) return [];

  const materials = read(item, 'craftingMats', 'CraftingMats');
  if (!Array.isArray(materials) || materials.length === 0) {
    return [{
      code: 'EQUIPMENT_SALVAGE_MATERIALS_MISSING',
      message: 'No crafting materials configured. Salvage removes this equipment without returning materials.',
    }];
  }

  return [];
}

export function validateAdminContent({ items = [], itemTypes = [] } = {}) {
  return items.flatMap(item => itemContentIssues(item, itemTypes)
    .map(issue => ({
      ...issue,
      entityId: id(item),
      entityName: String(read(item, 'name', 'Name') || id(item)),
      entityType: 'Item',
      severity: 'warning',
    })));
}
